import React, { useState } from "react";
import { Grid, Typography, Button, TextField, IconButton, Paper } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import useAuth from './useAuth.js';
import { useNotification } from "../../components/NotificationContext";

const CouponAdd = () => {
    useAuth();
    const showNotification = useNotification();
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const [couponName, setCouponName] = useState("");
    const [usageLimit, setUsageLimit] = useState("");
    const [discountPercent, setDiscountPercent] = useState("");

    const handleBackClick = () => {
        navigate(-1);
    };

    const handleSubmit = async () => {
        if (!couponName || !usageLimit || !discountPercent) {
            showNotification("Lütfen tüm alanları doldurun", "error");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/product/coupon`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({
                    name: couponName,
                    usage_limit: usageLimit,              
                    discount_percent: discountPercent
                }),
            });

            const data = await response.json();

            if (response.ok) {
                showNotification("Kupon başarıyla eklendi", "success");
                navigate(-1);
            } else {
                showNotification(data.message || "Bir hata oluştu", "error");
            }
        } catch (error) {
            console.error("Kupon ekleme hatası:", error);
            showNotification("Sunucu hatası oluştu", "error");
        }
    };

    return (
        <Grid container justifyContent="center" alignItems="center">
            <Grid size={{ xs: 12, sm: 10,md:10 }}>
                <Paper elevation={5} style={{ padding: '30px', borderRadius: '15px', backgroundColor: '#ffffff' }}>
                    <IconButton onClick={handleBackClick} style={{ marginBottom: '10px' }}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h4" gutterBottom align="center" style={{ fontWeight: 600, color: '#3f51b5' }}>
                        Kupon Ekle
                    </Typography>

                    <TextField
                        fullWidth
                        label="Kupon İsmi"
                        variant="outlined"
                        margin="normal"
                        value={couponName}
                        onChange={(e) => setCouponName(e.target.value)}
                    />

                    <TextField
                        fullWidth
                        label="Kullanım Hakkı"
                        variant="outlined"
                        margin="normal"
                        value={usageLimit}
                        onChange={(e) => setUsageLimit(e.target.value)}
                    />

                    <TextField
                        fullWidth
                        label="İndirim Oranı (%)"
                        variant="outlined"
                        margin="normal"
                        inputProps={{ min: 1, max: 100 }}
                        value={discountPercent}
                        onChange={(e) => setDiscountPercent(e.target.value)}
                    />

                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        style={{ marginTop: "20px" }}
                        onClick={handleSubmit}
                    >
                        Kuponu Kaydet
                    </Button>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default CouponAdd;
